import Gerencial from './gerencial';
import Professor from './professor';
import Merenda from './merenda';

const allowed = true;

let allRouterChildren = [];

const home = [
  {
    path: '',
    name: 'home',
    meta: {
      allowed,
      hasProgress: true,
      breadCrumb: 'Início',
    },
    component: () => import('@/views/Home'),
  },
];

const forbidden = [
  {
    name: '403',
    path: '/403',
    meta: { allowed },
    component: () => import('@/views/error/403'),
  },
];

const notFound = [
  {
    path: '*',
    meta: { allowed },
    component: () => import('@/views/error/404'),
  },
];

allRouterChildren = allRouterChildren.concat(home, Gerencial, Professor, Merenda, forbidden, notFound);

const layoutRouter = [
  {
    path: '/',
    component: () => import('@/views/Layout'),
    props: true,
    meta: {
      guarded: true,
    },
    children: allRouterChildren,
  },
];

export default layoutRouter;
